<template>
<div>
    <pt-sub-title title="生命银行样本"></pt-sub-title>
    <el-alert title="注：CPS存储类订单没有相应的实验室订单" type="warning"
    description="报告状态 - 如果为“有报告”且“可见”，则客户应该在移动端能查看该样本报告" show-icon>
    </el-alert>
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table">
     <wt-table :list="tableData" :labels="tableLabels" :class="$style['life-bank-sample-table']">
       <template>
         <el-table-column label="报告名称" min-width="190">
           <template slot-scope="scope">
             <template v-if="scope.row.mallSample&&scope.row.mallSample.cpsReportInformation&&scope.row.mallSample.cpsReportInformation.length">
             <div v-for="(item,index) in scope.row.mallSample.cpsReportInformation" :key="index"
             :class="index<scope.row.mallSample.cpsReportInformation.length-1?'report-border-bottom':null">
               {{item.name||'--'}}
             </div>
             </template>
             <template v-else>--</template>
           </template>
         </el-table-column>
         <el-table-column label="报告链接" min-width="180">
            <template slot-scope="scope">
             <template v-if="scope.row.mallSample&&scope.row.mallSample.cpsReportInformation&&scope.row.mallSample.cpsReportInformation.length">
             <div v-for="(item,index) in scope.row.mallSample.cpsReportInformation" :key="index"
             :class="index<scope.row.mallSample.cpsReportInformation.length-1?'report-border-bottom':null">
               {{item.reportUrl||'--'}}
             </div>
             </template>
             <template v-else>--</template>
           </template>
         </el-table-column>
         <el-table-column label="报告类型">
           <template slot-scope="scope">
              <template v-if="scope.row.mallSample&&scope.row.mallSample.cpsReportInformation&&scope.row.mallSample.cpsReportInformation.length">
             <div v-for="(item,index) in scope.row.mallSample.cpsReportInformation" :key="index"
             :class="index<scope.row.mallSample.cpsReportInformation.length-1?'report-border-bottom':null">
               {{item.report_type||'--'}}
             </div>
             </template>
              <template v-else>--</template>
           </template>
         </el-table-column>
          <el-table-column label="报告年份" min-width="105">
             <template slot-scope="scope">
              <template v-if="scope.row.mallSample&&scope.row.mallSample.cpsReportInformation&&scope.row.mallSample.cpsReportInformation.length">
              <div v-for="(item,index) in scope.row.mallSample.cpsReportInformation" :key="index"
              :class="index<scope.row.mallSample.cpsReportInformation.length-1?'report-border-bottom':null">
                {{item.year||'--'}}
              </div>
             </template>
              <template v-else>--</template>
           </template>
          </el-table-column>
          <el-table-column label="报告时间" min-width="105">
             <template slot-scope="scope">
              <template v-if="scope.row.mallSample&&scope.row.mallSample.cpsReportInformation&&scope.row.mallSample.cpsReportInformation.length">
              <div v-for="(item,index) in scope.row.mallSample.cpsReportInformation" :key="index"
              :class="index<scope.row.mallSample.cpsReportInformation.length-1?'report-border-bottom':null">
                {{item.created_date||'--'}}
              </div>
             </template>
              <template v-else>--</template>
           </template>
          </el-table-column>
					<el-table-column label="是否续存">
						<template slot-scope="scope">
							{{ scope.row.mallSample&&scope.row.mallSample.renewContract?'是':"否" }}
						</template>
					</el-table-column>
         <el-table-column label="操作">
           <template slot-scope="scope">
             <template v-if="hasLabOrderView(scope.row)">
           <el-button type="text" @click="getOrder(scope.row)" v-if="isShowButton(scope.row)">查看实验室订单</el-button>
           <el-button v-else type="text" :disabled="true">无实验室订单</el-button>
           </template>
           <el-button type="text" v-if="isShowGoodsOrderButton(scope.row)" @click="viewGoodsOrder(scope.row)">查看商城订单</el-button>
           <el-button type="text" v-if="isShowButtonVisible(scope.row)" @click="mallSampleById(scope.row)">屏蔽</el-button>
            <el-button type="text" v-else @click="mallSampleById(scope.row)">解除屏蔽</el-button>
           <el-button type="text" v-if="isShowDelete(scope.row)" @click="handleDelete(scope.row)"">删除</el-button>
           </template>
         </el-table-column>
       </template>
     </wt-table>
     </wt-paged-table>
</div>
</template>
<script>
import { hasPermissions } from 'utils/permissions'
const PERM_ADULTLAB_OPERATION = 'PERM_ADULTLAB_OPERATION'// 查看/操作成人实验室订单权限
const PERM_LAB_OPERATION = 'PERM_LAB_OPERATION'// 查看/操作基因实验室订单权限
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      loading: false,
      page: 0
    }
  },
  computed: {
    HAS_PERM_ADULTLAB_OPERATION () {
      return hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_ADULTLAB_OPERATION)
    },
    HAS_PERM_LAB_OPERATION () {
      return hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_LAB_OPERATION)
    }
  },
  methods: {
    // 选择订单是否可查看（该用户是否有查看该实验室订单的权限）
    hasLabOrderView (val) {
      let mallSample = val.mallSample || {}
      return (mallSample.type === 'GENE' && this.HAS_PERM_LAB_OPERATION) || (mallSample.type === 'TOOTH' && this.HAS_PERM_ADULTLAB_OPERATION)
    },
    viewGoodsOrder (val) {
      let mallOrderId = val.mallSample && val.mallSample.mallOrderId
      this.$router.push('/mall-order-all/order-detail/' + mallOrderId + '/detail')
    },
    // 是否显示查看商城订单按钮
    isShowGoodsOrderButton (val) {
      return val.mallSample && val.mallSample.mallOrderId
    },
    // 是否显示屏蔽按钮
    isShowButtonVisible (val) {
      return val.mallSample && val.mallSample.visible
    },
    // 是否显示跳转实验室订单
    isShowButton (row) {
      return row.mallSample && ((row.mallSample.type === 'GENE' || row.mallSample.type === 'TOOTH') && row.mallSample.labOrderId)
    },
    // 是否显示删除按钮（CPS类型）
    isShowDelete (row) {
      return row.mallSample && row.mallSample.type === 'CPS'
    },
    // 删除样本
    handleDelete (row) {
      let mallSample = row.mallSample || {}
      this.$confirm('您确定删除该样本吗？删除后无法恢复。', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        this.$store.dispatch('deleteMallSample', mallSample.id).then(res => {
          this.loading = false
          this.$message.success('删除成功')
          this.getTableData(this.page)
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '删除失败')
        })
      }).catch(_ => {})
    },
    getOrder (row) {
      let routPath = row.mallSample.type === 'GENE' ? '/lab-order-detail/' : '/adult-sell-order-detail/'
      this.$router.push(routPath + row.mallSample.labOrderId)
    },
    mallSampleById (row) {
      let mallSample = row.mallSample || {}
      let message = mallSample.visible ? '您确定屏蔽该样本：设置该样本在C端不可见吗' : '您确定解除该样本屏蔽：设置该样本为C端可见吗'
      this.$confirm(message, '屏蔽提示').then(_ => {
        this.getMallSampleById(mallSample)
      })
    },
    getMallSampleById (mallSample) {
      this.loading = true
      this.$store.dispatch('getMallSampleById', mallSample.id).then(res => {
        this.loading = false
        this.getTableData(this.page)
        this.$message.success('操作成功')
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '操作失败')
      })
    },
    getTableData (page, next) {
      this.page = page
      let data = {
        mallUserId: this.id,
        pageableParam: {
          page: page,
          size: 10
        }
      }
      this.$store.dispatch('getUserSamples', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取样本失败')
        this.$refs.table.showReTry()
      })
    }
  }
}
</script>
<style module lang="less">
.life-bank-sample-table{
  :global{
    .report-border-bottom{
      border-bottom:solid 1px #000
    }
  .el-button{
    margin-right: 10px;
    margin-left: 0
  }
  }
}
</style>
